//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'ILinChildren',
  data() {
    return {
      form: {
        height:''
      },
      hasScore: false,
      disabled: false,
      num: '',
      num1: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        self.hasScore = true;
        self.num = Math.exp((6.741-80.409 / form.height)).toFixed(0)
        self.num1 = (0.111 *  Math.pow(form.height, 1.521)).toFixed(0)
        return String(self.num,self.num1)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ILinChildren.vue